import {EnvironmentConfig} from "./EnvironmentConfig";
import {MapPosition} from "../MapPosition";
import {Orientation} from "../Orientation";

export class SlideConfig {
  public cameraLatitude;
  public cameraLongitude;
  public cameraHeight;
  public cameraPitch;
  public cameraRoll;
  public cameraHeading;

  public environment:EnvironmentConfig;

  constructor() {
    this.environment = new EnvironmentConfig();
  }

  hasCameraPosition() {
    return (this.cameraLatitude && this.cameraLongitude && this.cameraHeight);
  }

  getCameraPosition():MapPosition {
    return new MapPosition({
      lat: this.cameraLatitude,
      lng: this.cameraLongitude,
      height: this.cameraHeight
    });
  }

  getCameraOrientation():Orientation {
    return new Orientation(
      this.cameraHeading ? this.cameraHeading : 0,
      this.cameraPitch ? this.cameraPitch : 0,
      this.cameraRoll ? this.cameraRoll : 0
    );
  }

  asJSON() {
    return JSON.stringify(this);
  }
}


